import React from 'react';

const Status = ({ status }) => (
  <div className="flex items-center gap-1 sm:gap-2 text-xs md:text-sm">
    <span className={`p-1 rounded-3xl ${status === 'IN_PROGRESS' ? 'bg-blue-500' : 'bg-lime-500'}`} />
    {status === 'IN_PROGRESS' ? 'В процесі' : 'Завершений'}
  </div>
);

export default Status;
